module.exports = __webpack_public_path__ + "static/img/bg.2a81b94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/huarong/bg.png
// module id = 2LcX
// module chunks = 1